import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Collapse } from "reactstrap";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import classname from "classnames";
import "./Navbar.css";

// i18n
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";

// Import ProfileMenu component
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu";

const Navbar = (props) => {
  // Dropdown states for each logical module
  const [dashboard, setDashboard] = useState(false);
  const [operations, setOperations] = useState(false);
  const [fleet, setFleet] = useState(false);
  const [tariff, setTariff] = useState(false);
  const [finance, setFinance] = useState(false);
  const [system, setSystem] = useState(false);

  // Timeout references for delayed dropdown closing
  const [dashboardTimeout, setDashboardTimeout] = useState(null);
  const [operationsTimeout, setOperationsTimeout] = useState(null);
  const [fleetTimeout, setFleetTimeout] = useState(null);
  const [tariffTimeout, setTariffTimeout] = useState(null);
  const [financeTimeout, setFinanceTimeout] = useState(null);
  const [systemTimeout, setSystemTimeout] = useState(null);

  useEffect(() => {
    const ul = document.getElementById("navigation");
    if (!ul) return;
    const items = ul.getElementsByTagName("a");
    removeActivation(items);
    for (let i = 0; i < items.length; ++i) {
      if (window.location.pathname === items[i].pathname) {
        activateParentDropdown(items[i]);
        break;
      }
    }
  });

  const removeActivation = (items) => {
    for (let i = 0; i < items.length; ++i) {
      const item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent && parent.classList.contains("active")) {
        parent.classList.remove("active");
      }
    }
  };

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active");
      const parent2 = parent.parentElement;
      if (parent2) {
        parent2.classList.add("active");
        const parent3 = parent2.parentElement;
        if (parent3) {
          parent3.classList.add("active");
        }
      }
    }
    return false;
  }

  // Delayed dropdown open / close
  const openDropdown = (setter, timeoutRef, setterRef) => {
    if (timeoutRef) clearTimeout(timeoutRef);
    setter(true);
  };

  const closeDropdown = (setter, timeoutRef, setterRef, delay = 250) => {
    const timeout = setTimeout(() => {
      setter(false);
    }, delay);
    setterRef(timeout);
  };

  // Close all immediately
  const closeAllDropdowns = () => {
    setDashboard(false);
    setOperations(false);
    setFleet(false);
    setTariff(false);
    setFinance(false);
    setSystem(false);

    if (dashboardTimeout) clearTimeout(dashboardTimeout);
    if (operationsTimeout) clearTimeout(operationsTimeout);
    if (fleetTimeout) clearTimeout(fleetTimeout);
    if (tariffTimeout) clearTimeout(tariffTimeout);
    if (financeTimeout) clearTimeout(financeTimeout);
    if (systemTimeout) clearTimeout(systemTimeout);
  };

  useEffect(() => {
    return () => {
      if (dashboardTimeout) clearTimeout(dashboardTimeout);
      if (operationsTimeout) clearTimeout(operationsTimeout);
      if (fleetTimeout) clearTimeout(fleetTimeout);
      if (tariffTimeout) clearTimeout(tariffTimeout);
      if (financeTimeout) clearTimeout(financeTimeout);
      if (systemTimeout) clearTimeout(systemTimeout);
    };
  }, [
    dashboardTimeout,
    operationsTimeout,
    fleetTimeout,
    tariffTimeout,
    financeTimeout,
    systemTimeout,
  ]);

  return (
    <React.Fragment>
      <div className="topnav shadow-sm" style={{ marginTop: "0" }}>
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu py-1"
            id="navigation"
          >
            {/* Brand Logo */}
            <div className="navbar-brand-custom d-flex align-items-center me-3">
              <i className="bx bxs-truck me-2 brand-icon text-primary" style={{ fontSize: "1.5rem" }}></i>
              <span className="brand-text fw-bold text-dark" style={{ fontSize: "1.2rem", letterSpacing: "0.5px" }}>
                KirayaGo
              </span>
            </div>

            <Collapse
              isOpen={true}
              className="navbar-collapse"
              id="topnav-menu-content"
              navbar
            >
              <ul className="navbar-nav align-items-center gap-1">
                {/* 1. Dashboard */}
                <li
                  className="nav-item dropdown"
                  onMouseEnter={() => openDropdown(setDashboard, dashboardTimeout, setDashboardTimeout)}
                  onMouseLeave={() => closeDropdown(setDashboard, dashboardTimeout, setDashboardTimeout)}
                >
                  <Link className="nav-link dropdown-toggle arrow-none" to="/dashboard">
                    <i className="bx bx-home-circle me-1" style={{ fontSize: "1.1rem" }}></i>
                    {props.t("Dashboard")}
                  </Link>
                </li>

                {/* 2. Operations & Dispatch */}
                <li
                  className="nav-item dropdown"
                  onMouseEnter={() => openDropdown(setOperations, operationsTimeout, setOperationsTimeout)}
                  onMouseLeave={() => closeDropdown(setOperations, operationsTimeout, setOperationsTimeout)}
                >
                  <Link className="nav-link dropdown-toggle arrow-none" to="/#">
                    <i className="bx bx-navigation me-1 text-primary" style={{ fontSize: "1.1rem" }}></i>
                    {props.t("Operations")}
                    <div className="arrow-down ms-1"></div>
                  </Link>
                  <div
                    className={classname("dropdown-menu shadow-lg border-0", { show: operations })}
                    onMouseEnter={() => openDropdown(setOperations, operationsTimeout, setOperationsTimeout)}
                    onMouseLeave={() => closeDropdown(setOperations, operationsTimeout, setOperationsTimeout)}
                  >
                    <Link to="/AssignDriver" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-map-pin me-2 text-primary font-size-16"></i>
                      {props.t("Live Dispatch / Assign Driver")}
                    </Link>
                    <Link to="/DriverForApproval" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-user-check me-2 text-success font-size-16"></i>
                      {props.t("Driver Approvals")}
                    </Link>
                    <Link to="/WithdrawalRequests" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-money-withdraw me-2 text-warning font-size-16"></i>
                      {props.t("Withdrawal Requests")}
                    </Link>
                  </div>
                </li>

                {/* 3. Fleet & Members */}
                <li
                  className="nav-item dropdown"
                  onMouseEnter={() => openDropdown(setFleet, fleetTimeout, setFleetTimeout)}
                  onMouseLeave={() => closeDropdown(setFleet, fleetTimeout, setFleetTimeout)}
                >
                  <Link className="nav-link dropdown-toggle arrow-none" to="/#">
                    <i className="bx bx-car me-1 text-success" style={{ fontSize: "1.1rem" }}></i>
                    {props.t("Fleet & Members")}
                    <div className="arrow-down ms-1"></div>
                  </Link>
                  <div
                    className={classname("dropdown-menu shadow-lg border-0", { show: fleet })}
                    onMouseEnter={() => openDropdown(setFleet, fleetTimeout, setFleetTimeout)}
                    onMouseLeave={() => closeDropdown(setFleet, fleetTimeout, setFleetTimeout)}
                  >
                    <Link to="/MemberMaster" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-group me-2 text-info font-size-16"></i>
                      {props.t("Member Master (Captains & Users)")}
                    </Link>
                    <Link to="/VehicleMaster" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-car me-2 text-success font-size-16"></i>
                      {props.t("Vehicle Master")}
                    </Link>
                    <Link to="/VehicleTypeMaster" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-layer me-2 text-warning font-size-16"></i>
                      {props.t("Vehicle Type Master")}
                    </Link>
                    <Link to="/VehicleCategoryMaster" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-category-alt me-2 text-danger font-size-16"></i>
                      {props.t("Vehicle Category Master")}
                    </Link>
                  </div>
                </li>

                {/* 4. Tariff & Commercials */}
                <li
                  className="nav-item dropdown"
                  onMouseEnter={() => openDropdown(setTariff, tariffTimeout, setTariffTimeout)}
                  onMouseLeave={() => closeDropdown(setTariff, tariffTimeout, setTariffTimeout)}
                >
                  <Link className="nav-link dropdown-toggle arrow-none" to="/#">
                    <i className="bx bx-purchase-tag-alt me-1 text-warning" style={{ fontSize: "1.1rem" }}></i>
                    {props.t("Tariff & Commercials")}
                    <div className="arrow-down ms-1"></div>
                  </Link>
                  <div
                    className={classname("dropdown-menu shadow-lg border-0", { show: tariff })}
                    onMouseEnter={() => openDropdown(setTariff, tariffTimeout, setTariffTimeout)}
                    onMouseLeave={() => closeDropdown(setTariff, tariffTimeout, setTariffTimeout)}
                  >
                    <Link to="/RateMaster" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-trip me-2 text-primary font-size-16"></i>
                      {props.t("Rate Master (Distance Slabs)")}
                    </Link>
                    <Link to="/VehicleRateMaster" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-money me-2 text-success font-size-16"></i>
                      {props.t("Vehicle Rate Master")}
                    </Link>
                    <Link to="/CommissionMaster" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-pie-chart-alt-2 me-2 text-info font-size-16"></i>
                      {props.t("Commission Master")}
                    </Link>
                    <Link to="/ChargeTypeMaster" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-plus-circle me-2 text-warning font-size-16"></i>
                      {props.t("Additional Charge Types")}
                    </Link>
                    <Link to="/CouponMaster" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-gift me-2 text-danger font-size-16"></i>
                      {props.t("Coupon & Promo Codes")}
                    </Link>
                  </div>
                </li>

                {/* 5. Finance & Accounts */}
                <li
                  className="nav-item dropdown"
                  onMouseEnter={() => openDropdown(setFinance, financeTimeout, setFinanceTimeout)}
                  onMouseLeave={() => closeDropdown(setFinance, financeTimeout, setFinanceTimeout)}
                >
                  <Link className="nav-link dropdown-toggle arrow-none" to="/#">
                    <i className="bx bx-calculator me-1 text-danger" style={{ fontSize: "1.1rem" }}></i>
                    {props.t("Finance & Reports")}
                    <div className="arrow-down ms-1"></div>
                  </Link>
                  <div
                    className={classname("dropdown-menu shadow-lg border-0", { show: finance })}
                    onMouseEnter={() => openDropdown(setFinance, financeTimeout, setFinanceTimeout)}
                    onMouseLeave={() => closeDropdown(setFinance, financeTimeout, setFinanceTimeout)}
                  >
                    <Link to="/VoucherEntry" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-edit-alt me-2 text-primary font-size-16"></i>
                      {props.t("Voucher Entry (Journal Adjustments)")}
                    </Link>
                    <div className="dropdown-divider"></div>
                    <Link to="/LedgerReport" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-receipt me-2 text-info font-size-16"></i>
                      {props.t("Ledger Statement")}
                    </Link>
                    <Link to="/ProfitLossReport" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-trending-up me-2 text-warning font-size-16"></i>
                      {props.t("Profit & Loss (P&L)")}
                    </Link>
                    <Link to="/BalanceSheet" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-book-content me-2 text-success font-size-16"></i>
                      {props.t("Balance Sheet")}
                    </Link>
                  </div>
                </li>

                {/* 6. System & Setup */}
                <li
                  className="nav-item dropdown"
                  onMouseEnter={() => openDropdown(setSystem, systemTimeout, setSystemTimeout)}
                  onMouseLeave={() => closeDropdown(setSystem, systemTimeout, setSystemTimeout)}
                >
                  <Link className="nav-link dropdown-toggle arrow-none" to="/#">
                    <i className="bx bx-slider-alt me-1 text-secondary" style={{ fontSize: "1.1rem" }}></i>
                    {props.t("System Setup")}
                    <div className="arrow-down ms-1"></div>
                  </Link>
                  <div
                    className={classname("dropdown-menu shadow-lg border-0", { show: system })}
                    onMouseEnter={() => openDropdown(setSystem, systemTimeout, setSystemTimeout)}
                    onMouseLeave={() => closeDropdown(setSystem, systemTimeout, setSystemTimeout)}
                  >
                    <Link to="/UserMaster" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-shield-quarter me-2 text-danger font-size-16"></i>
                      {props.t("System Users & Roles")}
                    </Link>
                    <Link to="/CityMaster" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-map me-2 text-primary font-size-16"></i>
                      {props.t("City Master")}
                    </Link>
                    <Link to="/StateMaster" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-map-alt me-2 text-success font-size-16"></i>
                      {props.t("State Master")}
                    </Link>
                    <div className="dropdown-divider"></div>
                    <Link to="/UpdateGlobalOptions" className="dropdown-item py-2" onClick={closeAllDropdowns}>
                      <i className="bx bx-cog me-2 text-secondary font-size-16"></i>
                      {props.t("Global Options & Settings")}
                    </Link>
                  </div>
                </li>
              </ul>
            </Collapse>

            {/* Right Side - Firm + Profile */}
            <div className="ms-auto d-flex align-items-center right-nav">
              <div className="firm-name-display d-flex align-items-center me-2">
                <i className="bx bx-building me-1 firm-icon text-primary"></i>
                <span className="fw-semibold font-size-13 text-dark">
                  {(() => {
                    try {
                      const authUser = JSON.parse(localStorage.getItem("authUser"));
                      return authUser && authUser.FirmName ? authUser.FirmName : "KirayaGo Logistics";
                    } catch (error) {
                      return "KirayaGo Logistics";
                    }
                  })()}
                </span>
              </div>

              <div className="profile-menu-container">
                <ProfileMenu />
              </div>
            </div>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout;
  return { leftMenu };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(Navbar))
);
